import { useEffect } from 'react';
import { useRouter } from '~/utils/navigation';
import { notificationDetailPageOpened, notificationClickToMyNotificationsDetailPageCTA } from '@comeon/analytics';
import { Collapse } from '@comeon/ui';
import Icon, { ICON_BOTTOM } from '~/components/icon/index.js';
import useTranslations from '~/components/translation/use-translations.ts';
import ButtonWrapper from '~/components/misc/button-wrapper.js';
import { Sidebar, SidebarContent } from '~/components/sidebar/index.js';
import handleCTAClick from './my-notifications-utils.js';
import IconArrowLinkLeft from '~/components/misc/icon-arrow-link-left.js';
import usePreprocess from './utils/usePreprocess.js';
import useBasePathname from '~/hooks/use-base-pathname';
// import TextWithEmbedData from './utils/text-with-embed-data.js';

const NotificationDetail = ({ item }) => {
	const _item = usePreprocess(item);
	// DataLayer Tracking
	// Notification Detail Page Trigger when notification additional screen is viewed
	useEffect(() => {
		notificationDetailPageOpened(
			`${_item.recurringNotificationId ? `r${_item.recurringNotificationId} - ` : ''}${_item.id} - ${_item.title}`
		);
	}, [_item.id, _item.title, _item.recurringNotificationId]);

	const router = useRouter();

	const textKeys = ['NOTIFICATION_DETAIL_EXPIRY_DATE', 'NOTIFICATIONS_TC_EXAMPLE'];

	const { translations, isLoadingTranslations } = useTranslations(textKeys);

	const basePathname = useBasePathname();

	if (!_item) {
		return null;
	}

	return isLoadingTranslations ? null : (
		<Sidebar>
			<SidebarContent>
				<div className="notification-detail-container">
					<div className="page-head image-header-container">
						<div className="page-head__left-side">
							<IconArrowLinkLeft
								href="/account/my-notifications"
								className="back js-back page-head__back u-show"
								data-at="backbutton-my-notifications-detail"
							/>
						</div>
					</div>
					{_item.image && <img className="detail-image" alt="" src={_item.image} />}

					<div>
						<h2 className="title">{_item.title}</h2>
						<p className="description">{_item.description}</p>
					</div>
					{_item.data && (
						<>
							{/* user end date */}
							{_item.data.DisplayedEndDate && (
								<ul className="data-list">
									<li className="list-item" key="Displayed End Date">
										<b>{translations.NOTIFICATION_DETAIL_EXPIRY_DATE}</b>
										<div className="u-notification-end-date">
											{new Date(_item.data.DisplayedEndDate).toLocaleDateString()}{' '}
											{new Date(_item.data.DisplayedEndDate).toLocaleTimeString([], {
												hour: '2-digit',
												minute: '2-digit',
												hour12: false
											})}
										</div>
									</li>
								</ul>
							)}
							{/* accordion */}
							{_item.data.Accordion && (
								<Collapse
									label={_item.data.Accordion.accordion_title}
									className="notification-accordion-wrapper"
									data-at="responsible-gaming-limits_details"
									iconBottom={<Icon type={ICON_BOTTOM} />}
								>
									<p className="notification-accordion-content">
										{_item.data.Accordion.accordion_content}
									</p>
								</Collapse>
							)}
						</>
					)}
				</div>
			</SidebarContent>
			{_item.ctaUrl && _item.ctaText && (
				<ButtonWrapper smallerPositionValue="sticky" biggerPositionValue="sticky" webkitSticky>
					<button
						className="btn my-notification-detail-CTA-button"
						data-at="notification-detail-cta-button"
						onClick={() => {
							notificationClickToMyNotificationsDetailPageCTA(
								`${_item.recurringNotificationId ? `r${_item.recurringNotificationId} - ` : ''}${
									_item.id
								} - ${_item.title} - ${_item.ctaUrl}`
							);
							handleCTAClick(_item, router, basePathname);
						}}
					>
						{_item.ctaText}
					</button>
				</ButtonWrapper>
			)}
		</Sidebar>
	);
};

export default NotificationDetail;
